/*
 * Mobile-only screen: report suspicious email form + message bar for errors.
 * Shown on all mobile devices (Android/iOS). No access denied or admin screens on mobile.
 * Errors (e.g. domain/forward not configured) are shown in the message bar.
 */

import React from "react";
import MessageBar from "../MessageBar.jsx";
import MobileEmailReport from "./MobileEmailReport.jsx";

export default function MobileReportScreen({
  message,
  getMessageBarClass,
  reportType,
  setReportType,
  reportAdditionalInfo,
  setReportAdditionalInfo,
  reportingEmail,
  onEmailReport,
}) {
  return (
    <div className="p-4 max-w-md min-h-[500px] flex flex-col gap-4">
      {message && (
        <MessageBar message={message} getMessageBarClass={getMessageBarClass} />
      )}

      <MobileEmailReport
        reportType={reportType}
        setReportType={setReportType}
        reportAdditionalInfo={reportAdditionalInfo}
        setReportAdditionalInfo={setReportAdditionalInfo}
        reportingEmail={reportingEmail}
        onReport={onEmailReport}
        standalone
      />
    </div>
  );
}
